import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import StickyPlayer from "@/components/StickyPlayer";
import HomePage from "@/pages/HomePage";
import ArchivePage from "@/pages/ArchivePage";
import AboutPage from "@/pages/AboutPage";
import EpisodePage from "@/pages/EpisodePage";
import MerchPage from "@/pages/MerchPage";
import SubscribePage from "@/pages/SubscribePage";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import "@/App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <div className="min-h-screen bg-[#0A0A0A] grain-overlay pb-28">
          <Header />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/archive" element={<ArchivePage />} />
            <Route path="/episodes" element={<Navigate to="/archive" replace />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/episode/:episodeId" element={<EpisodePage />} />
            <Route path="/merch" element={<MerchPage />} />
            <Route path="/subscribe" element={<SubscribePage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
          <Footer />
          <StickyPlayer />
        </div>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
